// API 응답 공통 타입
export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

// Product 타입
export interface Product {
  id: number;
  category: string;
  imageUrl: string;
  bgColor: string;
  displayOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  name: string;
  subtitle: string;
  excerpt: string;
  description: string;
  usage: string | null;
  features: string[];
  benefits: string[] | null;
  specifications: Record<string, string> | null;
}

// News 타입
export interface News {
  id: number;
  category: string;
  thumbnailUrl: string | null;
  contentImages: string[] | null;
  views: number;
  isPublished: boolean;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  excerpt: string;
  content: string;
  author?: string;

  // 관리자 전용 필드 (선택적)
  imageUrl?: string;  // thumbnailUrl의 별칭
  titleEn?: string;   // 영어 제목
  contentEn?: string; // 영어 본문
}

// API 에러 타입
export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}
